.lead-value {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    gap: 8px;
    background-color: var(--green-xlt);
    border-radius: 3px;
    height: 31px;
    width: fit-content;
    box-sizing: border-box;
}

.lead-value--mini {
    padding: 0 4px 0 4px;
    gap: 4px;
    height: 24px;
}
